/**
 * Spartan's `hlm-popover` only flips vertically (above/below the trigger) and never
 * pushes itself back into the viewport horizontally, so a `start`-aligned popover
 * near the right edge of the screen can overflow off-screen. Pick `end` instead
 * whenever there isn't enough room to the right of the trigger for the given width.
 */
export function estimatePopoverAlign(
  trigger: HTMLElement,
  estimatedContentWidth: number
): 'start' | 'end' {
  const { left } = trigger.getBoundingClientRect();
  const viewportWidth = globalThis.innerWidth;

  return left + estimatedContentWidth > viewportWidth ? 'end' : 'start';
}
